import '../styles/ClickableButton.css';
import { ANIMATION_TYPES, SIZES } from '../CONSTANTS'
import { useNavigate } from 'react-router';

export function NavButton ({ type, title, path }) {

    let navigate = useNavigate();

    // Send user to the appropriate URL on click
    function onClick () {
        navigate(`/${path}`)
    }

    return (
        <div
            id={`nav-button-${type}`}
            className='navButton-outer'
            onClick={onClick}
        >
            <h2 className={`text-${type}`} style={{fontSize: `${SIZES.FONT_SIZE_TERTIARY}px`}}>{title}</h2>
        </div>
    )
}